// extracted by mini-css-extract-plugin
module.exports = {"Summary":"summary_Summary__1r2u8"};